/**
 * TVC (Television Commercial) Uploader Specifications
 * 
 * Simple single-placement uploader for TVC content.
 * Used at both MCG and Marvel venues with same specs.
 */

// ============================================================
// TVC PLACEMENT
// ============================================================
export const TVC_PLACEMENT = {
  label: "Big Screen - TVC",
  placementId: "TVC",
};

// ============================================================
// UPLOADER SPEC
// ============================================================
export const TVC_SPEC = {
  label: "Big Screen - TVC",
  specId: "TVC",
  prefix: "TVC",
  ledType: "tvc",
  contentGroup: "singleAsset",
  maxFiles: 1,
  maxFileSize: 5 * 1024 * 1024 * 1024, // 5GB per file

  dimensions: [{ width: 1920, height: 1080 }],

  imageSpec: {
    allowed: true,
    width: 1920,
    height: 1080,
    extensions: ["jpg", "png"],
    requiresAlpha: false,
    inspectAlpha: true,
  },

  videoSpec: {
    allowed: true,
    width: 1920,
    height: 1080,
    frameRate: 25,
    formats: ["AVC"],
    extensions: ["mp4"],
    requiresAlpha: false,
    inspectAlpha: true,
    audio: { mode: "detect" },
  },
};

// ============================================================
// HELPER: Build human-readable spec label from spec object
// ============================================================
export function buildSpecLabel(spec = TVC_SPEC) {
  const parts = [];

  // Resolution
  const w = spec.videoSpec?.width || spec.imageSpec?.width;
  const h = spec.videoSpec?.height || spec.imageSpec?.height;
  if (w && h) parts.push(`${w}×${h}`);

  // Video format
  if (spec.videoSpec) {
    const exts = spec.videoSpec.extensions || [];
    if (exts.includes("mov")) {
      parts.push("MOV / MP4");
    } else {
      parts.push("MP4");
    }

    if (spec.videoSpec.formats?.includes("AVC")) parts.push("H.264");
    if (spec.videoSpec.formats?.includes("ProRes")) parts.push("ProRes");
    if (spec.videoSpec.frameRate) parts.push(`${spec.videoSpec.frameRate}fps`);
  }

  // Image
  if (spec.imageSpec?.allowed) {
    parts.push("Static JPG / PNG");
    parts.push("RGB");
  }

  return parts.join(" · ");
}

const tvcSpecs = {
  TVC_PLACEMENT,
  TVC_SPEC,
  buildSpecLabel,
};

export default tvcSpecs;
